export const slogans = [
    "Transforming processes",
    "Improving quality",
    "Defying risks",
];